import type { UserAccessEntry } from "@/features/identity-hub/api/identity-hub.api";

export type TenantRoleAssignment =
  | { kind: "grant"; userId: string; accessId: string; tenantId: string }
  | {
      kind: "replace";
      userId: string;
      oldAccessId: string;
      newAccessId: string;
      tenantId: string;
    }
  | { kind: "noop"; userId: string };

export function findTenantAccessEntry(
  entries: UserAccessEntry[] | undefined,
  tenantId: string,
): UserAccessEntry | undefined {
  return entries?.find((entry) => entry.access.tenantId === tenantId);
}

/** One role per tenant: grant when empty, replace when switching, no-op if same. */
export function planTenantRoleAssignment(
  userId: string,
  accessId: string,
  tenantId: string,
  entries: UserAccessEntry[] | undefined,
): TenantRoleAssignment {
  const existing = findTenantAccessEntry(entries, tenantId);
  if (!existing) {
    return { kind: "grant", userId, accessId, tenantId };
  }
  if (existing.accessId === accessId) {
    return { kind: "noop", userId };
  }
  return {
    kind: "replace",
    userId,
    oldAccessId: existing.accessId,
    newAccessId: accessId,
    tenantId,
  };
}
